import cookie from 'js-cookie';

export const AW_COOKIES = {
  AUTH_TOKEN: 'X-Auth-Token',
  LOGIN_TOKEN: 'X-Login-Token',
  REGION: 'X-Region',
  SESSION_ID: 'Session-ID',
};

export const getAuthCookies = () => {
  const authToken = cookie.get(AW_COOKIES.AUTH_TOKEN);
  const loginToken = cookie.get(AW_COOKIES.LOGIN_TOKEN);
  const sessionId = cookie.get(AW_COOKIES.SESSION_ID);

  return { authToken, loginToken, sessionId };
};
